export default function convertString(value) {
  if (value) {
    // value = value.toString().toLocaleLowerCase();
    // return value.replaceAll(".", "-");

    const search = ".";
    const replaceWith = "-";
    const result = value.split(search).join(replaceWith);
    return result;
  }

  return "id-not-set";
}
